import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledHealthyLungsIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M14.283 14.1208V6.11536C14.283 4.76288 15.6992 3.87747 16.9151 4.46981C20.4817 6.20739 22.7447 9.82722 22.7447 13.7946V18.2813C22.7447 19.2053 21.931 19.9179 21.0151 19.7959L20.6638 19.7492C18.8355 19.5057 17.125 18.7097 15.7614 17.4676C14.8197 16.6097 14.283 15.3947 14.283 14.1208Z",
			fill: "#F9D5D3",
			stroke: "#E95550",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.46167 14.1208V6.11536C9.46167 4.76288 8.04542 3.87747 6.82955 4.46981C3.26294 6.20739 0.999895 9.82722 0.999895 13.7946V18.2813C0.999895 19.2053 1.81364 19.9179 2.72956 19.7959L3.08079 19.7492C4.90917 19.5057 6.6196 18.7097 7.98319 17.4676C8.92494 16.6097 9.46167 15.3947 9.46167 14.1208Z",
			fill: "#F9D5D3",
			stroke: "#E95550",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.98 1.78125V7.42243M11.98 7.42243L16.1497 11.5921M11.98 7.42243L7.8103 11.5921",
			stroke: "#AA201B",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.49805 3.60156C3.85113 4.09645 4.26432 4.51399 4.74609 4.85156C5.25921 5.21109 5.8372 5.46867 6.47656 5.64258C5.95752 5.9955 5.51792 6.40572 5.16602 6.88672C4.81558 7.36574 4.56229 7.90177 4.39258 8.49316C4.04228 8.00292 3.63137 7.59101 3.15039 7.25781C2.63512 6.90092 2.05428 6.64167 1.41406 6.45996C1.97637 6.07078 2.44544 5.62412 2.80859 5.10156C3.12407 4.64756 3.35182 4.14832 3.49805 3.60156Z",
			fill: "#EDFDFF",
			stroke: "#007AAF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.498 15.6016C18.8511 16.0964 19.2643 16.514 19.7461 16.8516C20.2592 17.2111 20.8372 17.4687 21.4766 17.6426C20.9575 17.9955 20.5179 18.4057 20.166 18.8867C19.8156 19.3657 19.5623 19.9018 19.3926 20.4932C19.0423 20.0029 18.6314 19.591 18.1504 19.2578C17.6351 18.9009 17.0543 18.6417 16.4141 18.46C16.9764 18.0708 17.4454 17.6241 17.8086 17.1016C18.1241 16.6476 18.3518 16.1483 18.498 15.6016Z",
			fill: "#EDFDFF",
			stroke: "#007AAF"
		})
	]
});
const ForwardRef = forwardRef(SvgFilledHealthyLungsIcon);
const Memo = memo(ForwardRef);
export default Memo;
